import styled from 'styled-components'


export const ModalInner = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 4rem;
  position: relative;
  form {
    width: 100%;
  }
  @media (min-width: 768px){
    margin: 0;
  }
`


export const Loading = styled.div`
  position: absolute;
  top: 0rem;
  left: -1rem;
  right: -1rem;
  bottom: -1rem;
  z-index: 3;
  display: flex;
  background: white;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: ${props => props.theme.colors.primary};
`


export const StepsWrapper = styled.div`
  margin: 0 3rem;
  margin-bottom: 1rem;

  .ant-steps-label-horizontal{
    display: flex;
  }
  .ant-steps-item-content{
    display: none !important;
  }

  @media (min-width: 768px) {
    margin: 0 5rem;
    margin-bottom: 1rem;
    display: block;
    .ant-steps-item-content{
      display: inline-block !important;
    }
  }

`

export const ModalColumn = styled.div`

  width: 100%;



  @media (min-width: 768px){
    padding: 0;
    margin-bottom: 1rem;
    ${props => props.left
    ?
      `width: 40%;
      padding-right: 2rem;
      `
    : `
      width: 50%;
      padding-left: 2rem;
  `};
  }


  form {

    button {
      position: fixed;
      right: 1rem;
      bottom: 1rem;
      z-index: 2;
      

      @media (min-width: 768px) {
        position: absolute;
        width: auto;
        left: auto;
        right: 0;
        bottom: 0;
      }
    }

  }


  .ant-table-wrapper {
    td, tr, th {
      padding: .25rem !important;
      margin: 0;
    }
    
    .ant-table-content,
    .ant-table-body {
      margin: 0;
    }
  }




  

`


export const HeadCell = styled.div`

  font-size: 1.125rem;
  position: relative;

  &:before{
    content:"";
    position: absolute;
    bottom: 0rem;
    height: 2px;
    width: 5rem;
    left: 50%;
    transform: translate(-50%,0);
    right: 0;
    background: ${props => props.color || props.theme.colors.primary};
  }

  @media (min-width: 768px){
    font-size: 1.75em;
  }
`
export const Cell = styled.div`
  text-align: center;
  svg {
    fill: ${props => props.available ? '#28a745' : '#dc3545'}
  }
`

export const Text = styled.div`
  font-size: .75rem;
`

export const TableWrapper = styled.div`


  .ant-table-thead > tr > th {
    text-align: center;
  }

  .ant-table-placeholder {
    display: none;
  }
  td {
    border-bottom: 0;
  }

`

export const Usage = styled.div`
  color: black;
  display: flex;
  &:hover{
    cursor: pointer;
    color: ${props => props.theme.colors.primary};
    svg {
      color: ${props => props.theme.colors.primary};
      border: 1px solid ${props => props.theme.colors.primary};
    }
  }
`

export const UsageText = styled.div`

`;

export const ModalContent = styled.div`
  font-size: 1.25rem;
`

export const TooltipWrapper = styled.div``

export const IconWrapper = styled.span`
  margin-left: .5rem;
  
  svg {
    border: 1px solid black;
    border-radius: 50%;
    padding: .1rem;
    /* &:hover{
      background-color: ${props => props.theme.colors.primary};
      color: white;
      cursor: pointer;
      border: 1px solid ${props => props.theme.colors.primary};
    } */
  }
`

export const ModalTitle = styled.h2`

  position: relative;
  display: inline-block;
  margin-bottom: 1rem;

  &:before{
    content:"";
    position: absolute;
    bottom: 0rem;
    height: 2px;
    width: 5rem;
    left: 50%;
    transform: translate(-50%,0);
    right: 0;
    background: ${props => props.color || props.theme.colors.primary};
  }


`
export const ModalSubtitle = styled.div`
  font-size: 1rem;
  font-weight: 300;

  margin-bottom: 1rem;
`

export const Plans = styled.div`
  display: ${props => props.version === "copy" && "none"};

  @media (min-width: 768px){
    display: ${props => props.version !== "copy" && "flex"};

    ${props => props.version === "copy" && `
      opacity: 0;
      background-white;
      display: flex;
      position: fixed;
      top: 0;
      transform: translate(0,-100%);
      z-index: 1;
      padding-left: ${props.usageWidth}px;
      right: 0;
      left: 0;
      margin: 0 auto;
      max-width: calc(1220px - 2rem);
      transition: .75s opacity, .5s transform;
      &:before {
        content: "";
        position: absolute;
        left: ${props.usageWidth}px;
        right: 0;
        background-color: white;
        bottom: 0;
        top: 0;
        z-index: -1;
      }
    `}
   

    ${props => (props.version === "copy" && props.isSticky ) && `
      top: 0;
      transform: translate(0,0);
      opacity: 1;
    `}
  }
`;
export const Plan = styled.div`
  border: 1px solid #e8e8e8;
  margin-bottom: 1rem;
  text-align: center;
  min-width: 350px;
  padding: 1.5rem;
  display: flex;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.15);
  flex-direction: column;

  button {
    margin: 1rem 0;
  }
  @media (min-width: 768px){
    min-width: auto;
    width: 25%;
    margin-right: 1rem;
    margin-bottom: 0;
    
    &:last-child {
      margin: 0;
    }
  }

  ${props => props.version === "copy" && `
      background-color: white;
      width: 25%;
      text-align: center;
      display: flex;
      justify-content: center;
      padding: .5rem;
      button {
        margin-bottom: 0;
      }

  `};
  
`


export const PlanTitle = styled.div`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  position: relative;


  &:before{
    content:"";
    position: absolute;
    bottom: 0rem;
    height: 2px;
    width: 5rem;
    left: 50%;
    transform: translate(-50%,0);
    right: 0;
    background: ${props => props.color || props.theme.colors.primary};
  }
`


export const PlanContent = styled.div`
  flex-basis: 100%;
  font-weight: 300;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const PlanText = styled.div`
  margin-bottom: 1rem;
`
export const PlanPriceWrapper = styled.div`
 
`
export const PlanPricePre = styled.span`
 font-size: .5rem;
`
export const PlanPriceCurrency = styled.span`
  position: relative;
  top: -1rem;
  margin-left: .5rem;
`
export const PlanPrice = styled.span`
  font-weight: 600;
  display: inline-block;
  font-size: 2rem;
  position: relative;
  margin-right: .5rem;
  &:after{
    content: "";
    position: absolute;
    right: -1.25rem;
    bottom: 50%;
    width: 1.75rem;
    height: 1px;
    background: black;
    transform: rotate(-75deg);
  }
 
`
export const PlanPricePost = styled.span`
  font-size: .75rem;
`


export const PlanFooter = styled.div`
  ${props => props.version !== "copy" && `flex:${props.usageWidth}px 0 0;`}
  font-size: .75rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  button {
    text-transform: uppercase;
  }
`
export const Plandescription = styled.div`
  margin-bottom: .25rem;

${props => props.index === 0 && ''};
${props => props.index === 1 && ''};
${props => props.index === 2 && ''};
${props => props.index === 3 && ''};
${props => props.index === 4 && ''};
`




export const SummaryCard = styled.div`


  background: ${props => props.theme.colors.lightGray.secondary};
  box-shadow: 0px 2px 8px rgba(0,0,0,0.15);
  padding: .5rem;
  height: 100%;
  border: 1px solid ${props => props.theme.colors.lightGray.primary};

  overflow: hidden;




`





export const SummaryCardHeader = styled.div`
  position: relative;
`
export const SummaryCardTitle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 2rem;
  font-weight: 300;
  text-transform: uppercase;
`

export const SummaryCardText = styled.div`
  font-size: .875rem;
  margin-bottom: .5rem;
`
export const SummaryCardCollapser = styled.div`

  position: absolute;

  top:50%;
  transform: translate(0,-50%);
  right: 0;
  @media (min-width: 768px){
    display: none;
  }
  button {
    border: none;
  }
`


export const SummaryCardContent = styled.div`
  display: ${props => props.isSummaryCardActive ? 'none' :'block'};
 

  @media (min-width: 768px){
    display: auto;
  }
`


export const SummaryCardItems = styled.div`
  margin-bottom: 1rem;
`



export const SummaryCardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`



export const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: ${props => props.theme.colors.lightGray.secondary};
  border-top: 1px solid ${props => props.theme.colors.gray.secondary};
  z-index: 1;
  
  @media (min-width: 768px){
    position: relative;
    background: transparent;
    border: none;
    padding: 0;
  }

`

export const Thankyou = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;

  *{

  font-size: 1.25rem;
  }
  span {
    color: ${props => props.theme.colors.primary};
  }
  strong {
    font-weight: 600;
  }
`